import { CeruleanButton } from 'components/Button'
import I18n from 'components/I18n'
import { OverlayLoader } from 'components/Loaders'
import ComponentsModal from 'components/Modal'
import { actions, selectors } from 'data'
import messages from 'lang'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { color, screenWidth } from 'utils'
import { isEmailVerified } from 'utils/user'

const Modal = styled(ComponentsModal)`
  padding: 2rem;
  width: 30rem;
  background: ${color('dark700')};
  color: ${color('white')};
  text-align: center;

  footer {
    margin-top: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    button {
      width: 100%;
    }
  }

  @media only screen and (max-width: ${screenWidth('sm')}) {
    width: 100%;
  }
`

const VerifyEmail = ({ onDone }) => {
  const dispatch = useDispatch()
  const user = useSelector(selectors.auth.getUser)

  useEffect(function pollUserEffect() {
    const interval = setInterval(() => {
      dispatch(actions.auth.getUser())
    }, 5000)
    return () => clearInterval(interval)
  }, [])

  useEffect(function checkEmailVeriedEffect() {
    if (!user) {
      // Logged out or expired session
      onDone()
      return
    }
    if (isEmailVerified(user)) {
      onDone()
    }
  })

  const sendCode = () => {
    dispatch(
      actions.analytics.trackEvent({
        key: 'Email Verification Requested',
        properties: {
          origin: 'SIGN_UP',
          user_id: user?.id
        }
      })
    )
    dispatch(actions.signup.resendCode())
  }

  useEffect(function sendEmailOnMount() {
    sendCode()
  }, [])

  if (!user) return <OverlayLoader />

  return (
    <Modal>
      <h1>
        <I18n data={messages.title_verify_email} />
      </h1>
      <p>
        <I18n data={messages.sub_title_verify_email} email={<b>{user.email}</b>} />
      </p>
      <p>
        <I18n data={messages.verify_email_notice} />
        <br />
        <I18n data={messages.verify_email_spam_warn} />
      </p>

      <footer>
        <CeruleanButton e2e='sendAgainButton' onClick={sendCode}>
          <I18n data={messages.resend_link} />
        </CeruleanButton>
      </footer>
    </Modal>
  )
}

export default VerifyEmail
